// test2497
(2497 && 0);
